module.exports = __webpack_public_path__ + "static/img/summer_huajiaoPic.0370e06d.png";